import { t } from "i18next";
import { logout } from "./config/authsave";
import Swal from "sweetalert2";
// --- ค่าคงที่สำหรับ Inactivity Detection ---
const activityEvents = [
  "mousemove",
  "keypress",
  "click",
  "scroll",
  "touchstart",
];

/**
 * getRandomNumber10To15
 * * @returns {number} - เลขจำนวนเต็มสุ่มระหว่าง 10 ถึง 15 (รวมค่า 10 และ 15)
 */
const getRandomNumber10To15 = () => {
  // ค่าต่ำสุดที่ต้องการ (รวม)
  const min = 10;
  // ค่าสูงสุดที่ต้องการ (รวม)
  const max = 15;

  // สูตร: Math.floor(Math.random() * (max - min + 1)) + min
  // 1. (max - min + 1) คือขนาดของช่วงที่เป็นไปได้ (15 - 10 + 1 = 6)
  // 2. Math.random() จะให้ค่าระหว่าง 0 (รวม) ถึง 1 (ไม่รวม)
  // 3. Math.random() * (max - min + 1) จะให้ค่าระหว่าง 0 (รวม) ถึง 6 (ไม่รวม)
  // 4. Math.floor(...) จะปัดเศษลง ให้ค่าจำนวนเต็มระหว่าง 0, 1, 2, 3, 4, 5
  // 5. + min จะปรับช่วงของตัวเลขให้เริ่มต้นจาก 10 (10 + 0 ถึง 10 + 5)
  return Math.floor(Math.random() * (max - min + 1)) + min;
};
let luckyNumber = getRandomNumber10To15();
let IDLE_TIME_LIMIT = luckyNumber * 60 * 1000;
// --- ตัวแปรสำหรับ Inactivity Detection ---
let idleTimer = null;
const alertShownKey = "appLogoutAlertShown";
let alertShown = sessionStorage.getItem(alertShownKey);

/**
 * ฟังก์ชัน debounce: ใช้เพื่อจำกัดความถี่ในการเรียกใช้ฟังก์ชัน
 * @param {function} func - ฟังก์ชันที่จะถูกเรียก
 * @param {number} delay - ระยะเวลา (มิลลิวินาที) ที่จะรอหลังจากเรียกครั้งสุดท้าย ก่อนที่จะเรียกฟังก์ชันจริง
 * @returns {function} - ฟังก์ชันที่ถูก debounced
 */
function debounce(func, delay) {
  let timeout;
  return function (...args) {
    const context = this;
    clearTimeout(timeout);
    timeout = setTimeout(() => func.apply(context, args), delay);
  };
}

/**
 * จัดการการ Logout และแสดง Alert
 * @param {string} message - ข้อความที่จะแสดงใน Alert
 */
const handleLogoutAndAlert = (message) => {
  if (alertShown) {
    console.log(`alertShown: ${alertShown}`);
    return;
  }
  sessionStorage.setItem(alertShownKey, "true");

  let timerInterval;
  Swal.fire({
    title: `${t(message)}`,
    html: `${t("session_timeout.description")}`,
    icon: "question",
    timer: 90000,
    timerProgressBar: true,
    footer: `<div class="text-center">${t("Log out in")} <b style="color:red;"></b></div>`,
    showCancelButton: false,
    confirmButtonText: `${t("session_timeout.btn_continue")}`,
    confirmButtonColor: "#3085d6",
    reverseButtons: true,
    showClass: {
      popup: `
      animate__animated
      animate__fadeInUp
      animate__faster
    `,
    },
    hideClass: {
      popup: `
      animate__animated
      animate__fadeOutDown
      animate__faster
    `,
    },
    didOpen: () => {
      const b = Swal.getFooter().querySelector("b");
      timerInterval = setInterval(() => {
        if (b) {
          let s = Math.ceil(Swal.getTimerLeft() / 1000);
          b.textContent = `${s} ${t("second")}`;
        }
      }, 100);
    },
    willClose: () => {
      clearInterval(timerInterval);
    },
  }).then((result) => {
    if (result.isConfirmed) {
      debouncedResetIdleTimer();
      sessionStorage.removeItem(alertShownKey);
    } else if (
      result.dismiss === Swal.DismissReason.timer ||
      result.isDismissed
    ) {
      logout();
      stopInactivityManager();
    }
  });
};

/**
 * ฟังก์ชัน debounce สำหรับ resetIdleTimer
 */
const debouncedResetIdleTimer = debounce(() => {
  if (idleTimer) {
    clearTimeout(idleTimer);
  }
  idleTimer = setTimeout(() => {
    handleLogoutAndAlert(`session_timeout.title`);
  }, IDLE_TIME_LIMIT);
}, 300);

/**
 * เพิ่ม Event Listeners สำหรับการตรวจจับกิจกรรมของผู้ใช้
 */
const addActivityListeners = () => {
  activityEvents.forEach((event) => {
    document.addEventListener(event, debouncedResetIdleTimer);
  });
};

/**
 * ลบ Event Listeners ทั้งหมด
 */
const removeActivityListeners = () => {
  activityEvents.forEach((event) => {
    document.removeEventListener(event, debouncedResetIdleTimer);
  });
};

/**
 * ฟังก์ชันหลักในการเริ่มต้นการจัดการ Inactivity Detection
 */
export const startInactivityManager = () => {
  console.log("Motion detector: start");
  console.log(`IDLE_TIME_LIMIT: ${luckyNumber}`);
  getRandomNumber10To15();
  addActivityListeners();
  debouncedResetIdleTimer(); // เริ่มจับเวลาครั้งแรก
};

/**
 * ฟังก์ชันสำหรับหยุดการจัดการ Inactivity Detection
 */
export const stopInactivityManager = () => {
  console.log("Motion detector: stop");
  if (idleTimer) {
    clearTimeout(idleTimer);
    idleTimer = null;
  }
  removeActivityListeners();
};
